// i18n locale set. The toggle switches EVERY string.
//
// Design: the English source string IS the message key (gettext-style). A missing
// translation entry falls back to the English source — so the app can never render
// a raw "nav.home"-style key, and partial coverage degrades to English rather than
// to breakage. See src/i18n/index.tsx.
//
// English + Hindi + Bengali are curated seed + machine sweep. Tamil / Telugu /
// Marathi / Kannada (Conv-28), Gujarati / Punjabi / Assamese and Malayalam are
// machine sweep only. Since 2026-10-19 (founder decision) compliance strings are
// machine-translated too, in every locale, and recorded as awaiting a native
// speaker's check in machine-translated-compliance.json.

export type Locale =
  | 'en-IN'
  | 'hi-IN'
  | 'bn-IN'
  | 'ta-IN'
  | 'te-IN'
  | 'mr-IN'
  | 'kn-IN'
  | 'gu-IN'
  | 'pa-IN'
  | 'as-IN'
  | 'ml-IN';

export const SUPPORTED_LOCALES: Locale[] = [
  'en-IN',
  'hi-IN',
  'bn-IN',
  'ta-IN',
  'te-IN',
  'mr-IN',
  'kn-IN',
  'gu-IN',
  'pa-IN',
  'as-IN',
  'ml-IN',
];

export const LOCALE_LABELS: Record<Locale, string> = {
  'en-IN': 'English',
  'hi-IN': 'हिन्दी',
  'bn-IN': 'বাংলা',
  'ta-IN': 'தமிழ்',
  'te-IN': 'తెలుగు',
  'mr-IN': 'मराठी',
  'kn-IN': 'ಕನ್ನಡ',
  'gu-IN': 'ગુજરાતી',
  'pa-IN': 'ਪੰਜਾਬੀ',
  'as-IN': 'অসমীয়া',
  'ml-IN': 'മലയാളം',
};

// Short label for compact switchers (header pill).
export const LOCALE_SHORT: Record<Locale, string> = {
  'en-IN': 'EN',
  'hi-IN': 'हि',
  'bn-IN': 'বাং',
  'ta-IN': 'த',
  'te-IN': 'తె',
  'mr-IN': 'मरा',
  'kn-IN': 'ಕನ್',
  'gu-IN': 'ગુ',
  'pa-IN': 'ਪੰ',
  'as-IN': 'অস',
  'ml-IN': 'മല',
};

// Legacy en-US round-trips to en-IN (founder ruling Conv-24: language, not region).
// Any unrecognised value fails safe to English.
export const normalizeLocale = (raw?: string | null): Locale =>
  (SUPPORTED_LOCALES as string[]).includes(raw ?? '') ? (raw as Locale) : 'en-IN';
